import React, { createContext, useCallback, useContext, useState } from "react";

export interface Ribbon {
  type: "info" | "error";
  isOpen: boolean;
  message: string;
}

type RibbonContextType = {
  ribbons: Ribbon[];
  addRibbon: (message: string, type: "info" | "error") => void;
  removeRibbon: (index: number) => void;
};

const RibbonContext = createContext<RibbonContextType>({
  ribbons: [],
  addRibbon: () => {},
  removeRibbon: () => {},
});

export const RibbonProvider = ({ children }: { children: React.ReactNode }) => {
  const [ribbons, setRibbons] = useState<Ribbon[]>([]);

  const addRibbon = useCallback((message: string, type: "info" | "error") => {
    setRibbons((prev) => [
      ...prev,
      {
        type,
        isOpen: true,
        message,
      },
    ]);
  }, []);

  const removeRibbon = useCallback((index: number) => {
    setRibbons((prev) => prev.filter((_, i) => i !== index));
  }, []);

  return (
    <RibbonContext.Provider value={{ ribbons, addRibbon, removeRibbon }}>
      {children}
    </RibbonContext.Provider>
  );
};

export const useRibbon = () => useContext(RibbonContext);
